import { render, staticRenderFns } from "./SubcategoryItems.vue?vue&type=template&id=45126382&scoped=true"
import script from "./SubcategoryItems.vue?vue&type=script&lang=js"
export * from "./SubcategoryItems.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryItems.vue?vue&type=style&index=0&id=45126382&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45126382",
  null
  
)

export default component.exports